export const MODAL_IMAGE_HEIGHT = 165;
export const MODAL_TEXT_HEIGHT = 45;
